import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlService } from './url.service';
import { catchError, EMPTY, Observable } from 'rxjs';
import { Workspace } from '../models/Workspace';
import { FabricItem } from '../models/FabricItem';

@Injectable({
  providedIn: 'root'
})
export class FabricService {
  private readonly url: string;

  constructor(private readonly http: HttpClient, private readonly urlService: UrlService) {
    this.url = this.urlService.generateUrl('Fabric');
  }

  getAllWorkspaces(): Observable<Workspace[]> {
    return this.http.get<Workspace[]>(`${this.url}/GetAllWorkspaces`).pipe(
      catchError((error: any) => this.handleError(error))
    );
  }

  getAllItemsByType(workspaceId: string, type: string): Observable<FabricItem[]> {
    return this.http.get<FabricItem[]>(`${this.url}/GetItemsByType`, {
      params: { workspaceId, type }
    }).pipe(
      catchError((error: any) => this.handleError(error))
    );
  }

  getItemParameters(workspaceId: string, artifactId: string, type: string): Observable<any> {
    return this.http.get<any>(`${this.url}/GetItemParameters`, {
      params: { workspaceId, artifactId, type}
    }).pipe(
      catchError((error: any) => this.handleError(error))
    );
  }

  runJob(item: FabricItem, itemType: string): Observable<string> {
    return this.http.post<string>(`${this.url}/RunJob?itemType=${itemType}`, item, {
      responseType: 'text' as 'json' // Tell Angular to treat the response as plain text
    });
  }

  private handleError(error: any): Observable<never> {
    return EMPTY;
  }
}